<template>
  <div class="order-promotion">
    <nav-bar
      fixed
      z-index="99"
      title="订单推广"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>

    <!-- 套餐选择和生成区域 -->
    <div class="package-box">
      <div class="package-title">生成推广链接</div>

      <div class="package-form">
        <div class="form-item">
          <div class="form-label">套餐选择</div>
          <div class="form-input">
            <field
              v-model="packageName"
              readonly
              clickable
              label=""
              placeholder="请选择套餐"
              is-link
              @click="showPackagePicker = true"
            />
            <popup v-model="showPackagePicker" position="bottom">
              <picker
                show-toolbar
                :columns="packageOptions"
                @confirm="onPackageConfirm"
                @cancel="showPackagePicker = false"
                value-key="text"
              />
            </popup>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label">订单金额</div>
          <div class="form-input">
            <div class="amount">¥ {{ price || 0 }}</div>
          </div>
        </div>

        <div class="form-submit">
          <div class="submit-btn" @click="generateTemplate" :class="{ 'disabled': generating }">
            {{ generating ? '生成中...' : '确认生成' }}
          </div>
        </div>
      </div>
    </div>

    <!-- 已生成模板列表 -->
    <div class="template-section">
      <div class="section-title">已生成模板</div>

      <div class="promotion-list">
        <div v-if="loading" class="loading-container">
          <loading type="spinner" color="#0ce6df" />
          <p>加载中...</p>
        </div>

        <div v-else-if="templates.length === 0" class="empty-container">
          <empty description="暂无推广模板" />
        </div>

        <div v-else class="template-list">
          <div class="template-item" v-for="(item, index) in templates" :key="index">
            <div class="template-row">
              <div class="row-label">订单号:</div>
              <div class="row-content">{{ item.id || '暂无' }}</div>
            </div>

            <div class="template-row">
              <div class="row-label">订单名称:</div>
              <div class="row-content">{{ item.name || '暂无名称' }}</div>
            </div>

            <div class="template-row">
              <div class="row-label">订单金额:</div>
              <div class="row-content price">¥ {{ item.price || '0.00' }}</div>
            </div>

            <div class="template-row">
              <div class="row-label">分享链接:</div>
              <div class="row-content link">{{ item.shareLink || '暂无链接' }}</div>
            </div>

            <div class="template-row">
              <div class="row-label">创建时间:</div>
              <div class="row-content">{{ formatTime(item.createTime) || '暂无' }}</div>
            </div>

            <div class="template-actions">
              <div class="action-btn copy-btn" @click="copyShareLink(item)">
                复制链接发送给客户
              </div>
<!--               
              <div class="action-btn share-btn" @click="shareTemplate(item)">
                分享
              </div> -->
              
              <div class="action-btn delete-btn" @click="deleteTemplate(item)">
                删除
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Loading, Toast, Empty, Field, Popup, Picker } from 'vant';
import { getTemplateList, generateTemplateList,deleteTemplateById } from '@/api/user';
import { getCoachList, getProductDetail } from '@/api/store';

export default {
  name: 'OrderPromotion',
  components: {
    NavBar,
    Loading,
    Empty,
    Field,
    Popup,
    Picker
  },
  data() {
    return {
      loading: false,
      generating: false,
      templates: [],
      showPackagePicker: false,
      packageName: '',
      price: 0,//默认值
      isOpen: 0, //表示当前套餐是否打开
      unique:'',//唯一标识
      packageOptions: [//默认
      ],
      id: null, //商品id
      productDetail: null //商品详情
    };
  },
  mounted() {
    console.log('fetchTemplates');
    this.fetchTemplates();
    this.getCoachById();
  },
  methods: {
    // 删除模板
    deleteTemplate(item) {
      if (!item.id) {
        Toast.fail('无效的模板ID');
        return;
      }
      // 调用删除接口
      deleteTemplateById(item.id)
        .then(res => {
          console.log('删除模板返回数据:', res);
          if (res && res.status == 200) {
            Toast.success('模板删除成功');
            // 重新获取模板列表
            this.fetchTemplates();


          } else {
            Toast.fail(res.msg || '删除模板失败');
          }
        })
        .catch(err => {
          console.error('删除模板失败:', err);
          Toast.fail('删除模板失败，请稍后重试');
        });
    },
    fetchTemplates() {
      this.loading = true;

      // 为避免进入catch块，使用try-catch手动处理可能的错误情况
      getTemplateList()
        .then(res => {
          this.loading = false;
          // 处理直接返回数组的情况
          if (Array.isArray(res)) {
            this.templates = res;
            console.log('获取模板列表成功(直接数组):', res);
          }
          // 处理返回对象中包含data数组的情况
          else if (res && res.data) {
            this.templates = res.data;
            console.log('获取模板列表成功(data属性):', res.data);
          }
          // 处理接口返回失败但带有data的情况（可能是您的情况）
          else {
            this.templates = [];
            console.log('未获取到模板数据:', res);
          }
        })
        .catch(err => {
          // 特殊处理：检查错误对象中是否包含有效的data数组
          if (err && Array.isArray(err.data) && err.data.length > 0) {
            console.log('从错误中提取模板数据:', err.data);
            this.templates = err.data;
            this.loading = false;
            return;
          }

          this.loading = false;
          console.error('获取模板列表失败:', err);
          Toast.fail('获取推广模板失败，请稍后重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPackageConfirm(value) {//当用户选择不同的套餐时，更新套餐名称和价格
      this.packageName = value.text;
      // 更新价格
      this.price = value.price || '0';
      this.unique = value.unique;//选择套餐下不同的唯一标识
      this.showPackagePicker = false;
    },
    generateTemplate() {
      if (this.generating) return;
      if (!this.packageName) {
        Toast.fail('请先选择套餐');
        return;
      }

      this.generating = true;

      // 构建请求参数
      const templateData = {
        createTime: '',
        id: 0,
        name: this.packageName,
        price: parseFloat(this.price),
        productId: this.id,
        shareLink: '',
        unique: this.unique,//唯一标识符
        updateTime: ''
      };

      // 使用封装好的generateTemplateList方法
      generateTemplateList(templateData)
        .then(res => {
          this.generating = false;
          console.log('生成模板返回数据:', res);

          // 处理其他错误情况
          const isError = res &&
                        (res.code === 400 || res.code === 500 ||
                         res.status === 400 || res.status === 500);

          if (!isError) {
            Toast.success('推广模板生成成功');
            // 重新获取模板列表
            this.fetchTemplates();
          } else {
            Toast.fail(res.msg || res.message || '生成推广模板失败');
          }
        })
        .catch(err => {
          this.generating = false;
          console.error('生成推广模板失败:', err);

          // 检查错误对象本身是否包含5101状态码
          if (err && err.status === 5101) {
            Toast.fail(err.msg || '套餐不存在或未开启');
            return;
          }

          // 检查错误对象中是否包含data属性且data中有5101状态码
          if (err && err.data && err.data.status === 5101) {
            Toast.fail(err.data.msg || '套餐不存在或未开启');
            return;
          }

          Toast.fail('生成推广模板失败，请稍后重试');
        });
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
    copyShareLink(item) {
      if (!item.shareLink) {
        Toast.fail('分享链接不存在');
        return;
      }

      // 复制链接到剪贴板
      const input = document.createElement('input');
      input.value = item.shareLink;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);

      Toast.success('推广链接已复制到剪贴板');
    },
    shareTemplate(item) {
      if (!item.shareLink) {
        Toast.fail('分享链接不存在');
        return;
      }

      // 如果是在微信环境中，可以调用微信分享API
      // 这里简单实现为复制链接
      this.copyShareLink(item);
      Toast('请将复制的链接分享给好友');
    },
    getCoachById() {//获取商品id（目的通过商品id调用教练详情接口获取当前教练数据）
      getCoachList({name: this.$store.state.app.userInfo.realName})
        .then(res => {
          console.log('获取商品列表:', res);
          // 处理不同情况的响应数据格式
          if (Array.isArray(res) && res.length > 0) {//因为是通名称获取的商品列表所有我们要通过uid来遍历出对应的商品id
            for (let i = 0; i <= res.length; i++) {
              if (res[i].uid == this.$store.state.app.userInfo.uid) {
                    this.id = res[i].id;
              }
            }
            this.getProductDetail(); // 获取到ID后调用商品详情
          } else if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].uid == this.$store.state.app.userInfo.uid) {
                      this.id = res.data[i].id;
             }
           }
            this.getProductDetail(); // 获取到ID后调用商品详情
          } else {
            console.log('未找到匹配商品');
          }
        })
        .catch(err => {
          console.error('获取商品信息失败:', err);
        });
    },

    // 新增获取商品详情方法
    getProductDetail() {
      if (!this.id) {
        console.log('商品ID不存在，无法获取详情');
        return;
      }

      getProductDetail(this.id, {})
        .then(res => {
          console.log('获取商品详情成功:', res);
          // 提取productValue数据
          if (res.data && res.data.productValue) {
            // 直接保存productValue对象
            this.productDetail = res.data.productValue;
            console.log('提取到productValue数据:', this.productDetail);

            // 更新套餐选项
            this.updatePackageOptions();
          } else if (res && res.productValue) {
            this.productDetail = res.productValue;
            console.log('提取到productValue数据:', this.productDetail);

            // 更新套餐选项
            this.updatePackageOptions();
          } else {
            console.log('响应中未找到productValue数据');
          }
        })
        .catch(err => {
          console.error('获取商品详情失败:', err);
        });
    },

    // 根据商品详情更新套餐选项
    updatePackageOptions() {
      if (!this.productDetail) return;

      const options = [];

      // 始终添加第一个套餐选项（默认单次套餐）
      const keys = Object.keys(this.productDetail);
      if (keys.length > 0) {
        const firstKey = keys[0];
        const firstItem = this.productDetail[firstKey];
        if (firstItem && firstItem.skuName) {
          options.push({
            text: firstItem.skuName,
            value: firstKey,
            price: firstItem.price || '0.00',
            unique: firstItem.unique || '',
            isOpen: 1 // 强制设置为开启状态
          });
        }
      }

      // 然后添加其他isOpen=1的套餐（排除第一个套餐）
      Object.keys(this.productDetail).forEach((key, index) => {
        // 跳过第一个套餐，因为已经添加过了
        if (index === 0) return;

        const item = this.productDetail[key];
        if (item && item.skuName && item.isOpen === 1) {
          options.push({
            text: item.skuName,
            value: key,
            price: item.price || '0.00',
            unique: item.unique || '',
            isOpen: item.isOpen
          });
        }
      });

      if (options.length > 0) {
        this.packageOptions = options;
        console.log('套餐选项已更新:', this.packageOptions);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.order-promotion {
  min-height: 100vh;
  background-color: #f5f5f5;

  // 套餐选择区域样式
  .package-box {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 15px;

    .package-title {
      font-size: 0.34rem;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
      border-left: 4px solid #0ce6df;
      padding-left: 10px;
    }

    .package-form {
      .form-item {
        margin-bottom: 15px;

        .form-label {
          font-size: 0.3rem;
          color: #333;
          margin-bottom: 8px;
        }

        .amount {
          font-size: 0.34rem;
          color: #ee0a24;
          font-weight: bold;
          padding: 10px 0;
        }
      }

      .form-submit {
        margin-top: 20px;

        .submit-btn {
          background-color: #0ce6df;
          color: #fff;
          height: 44px;
          line-height: 44px;
          text-align: center;
          border-radius: 4px;
          font-size: 0.32rem;

          &:active {
            opacity: 0.8;
          }

          &.disabled {
            opacity: 0.6;
            background-color: #ccc;
          }
        }
      }
    }
  }

  // 模板列表区域样式
  .template-section {
    .section-title {
      font-size: 0.34rem;
      font-weight: bold;
      color: #333;
      padding: 0 15px;
      margin-bottom: 10px;
      border-left: 4px solid #0ce6df;
      margin-left: 15px;
    }
  }

  .promotion-list {
    padding: 0 15px 15px;
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;

    p {
      margin-top: 10px;
      color: #999;
    }
  }

  .empty-container {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  .template-list {
    .template-item {
      background-color: #fff;
      border-radius: 8px;
      margin-bottom: 15px;
      padding: 15px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

      .template-row {
        display: flex;
        margin-bottom: 10px;
        font-size: 0.28rem;

        .row-label {
          width: 90px;
          color: #666;
          flex-shrink: 0;
        }

        .row-content {
          flex: 1;
          color: #333;
          word-break: break-all;

          &.price {
            color: #ee0a24;
            font-weight: bold;
          }

          &.link {
            color: #0ce6df;
          }
        }
      }

      .template-actions {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;

        .action-btn {
          margin-left: 10px;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 0.28rem;

          &:active {
            opacity: 0.8;
          }
        }

        .copy-btn {
          background-color: #f2f3f5;
          color: #323233;
        }

        .share-btn {
          background-color: #0ce6df;
          color: #fff;
        }

        .delete-btn {
          background-color: #ee0a24;
          color: #fff;
        }
      }
    }
  }
}
</style>
